import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exito',
  templateUrl: './exito.component.html',
  styleUrls: ['./exito.component.css']
})
export class ExitoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
